export const SUPPORT_EMAIL = "support@qumashi.com";
export const INSTAGRAM_URL = "https://www.instagram.com/";
export const INSTAGRAM_HANDLE = "@";
export const PUBLIC_SITE_ORIGIN = "https://www.qumashi.com";
/** Fallback share image when a creator has no banner or avatar. */
export const DEFAULT_OG_IMAGE = `${PUBLIC_SITE_ORIGIN}/favicon.png`;
export const SUPPORT_RESPONSE_HOURS = 24;

export const NEWSLETTER_STORAGE_KEY = "qumashi-drop-alerts-v1";
